import { render, staticRenderFns } from "./MenuUser.vue?vue&type=template&id=73803e1a&scoped=true&"
import script from "./MenuUser.vue?vue&type=script&lang=js&"
export * from "./MenuUser.vue?vue&type=script&lang=js&"
import style0 from "./MenuUser.vue?vue&type=style&index=0&id=73803e1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73803e1a",
  null
  
)

export default component.exports